import { useEffect } from 'react';

export interface UseBufferedSearchOptions<T> {
  cb: (search: T) => any;
  search: T;
}

export const useBufferedSearch = <T>(props: UseBufferedSearchOptions<T>) => {
  useEffect(() => {
    if (props.search == null) {
      props.cb(props.search);
    }
    let res = setTimeout(() => {
      props.cb(props.search);
    }, 400);

    return () => {
      clearTimeout(res);
    };
  }, [props.search ? JSON.stringify(props.search) : null]);
};
